// Base scraper class for common functionality
import { logger } from '@podx/core';

export abstract class BaseScraper {
  protected scraper: any | null = null;

  constructor() {
    this.scraper = null;
  }

  protected async initializeScraper(): Promise<void> {
    if (!this.scraper) {
      // Import Scraper dynamically to avoid namespace issues
      const { Scraper } = require('agent-twitter-client');
      this.scraper = new Scraper();
      
      const username = process.env.XSERVE_USERNAME;
      const password = process.env.XSERVE_PASSWORD;
      const email = process.env.XSERVE_EMAIL;

      if (!username || !password) {
        throw new Error('Twitter credentials not configured. Please set XSERVE_USERNAME and XSERVE_PASSWORD environment variables.');
      }

      try {
        await this.scraper.login(username, password, email);
        logger.info('Successfully logged in to Twitter');
      } catch (error) {
        logger.error('Failed to login to Twitter', {}, error as Error);
        throw error;
      }
    }
  }

  protected ensureInitialized(): void {
    if (!this.scraper) {
      throw new Error('Scraper not initialized. Call initializeScraper() first.');
    }
  }

  public async logout(): Promise<void> {
    if (this.scraper) {
      await this.scraper.logout();
      this.scraper = null;
    }
  }
}